// extracted by mini-css-extract-plugin
export default {"itemBtn":"itemBtn--GHd2A","name":"name--uCYsV","kind-blue":"kind-blue--yAFqZ","lockIconWrapper":"lockIconWrapper--PYrhf"};